import React, { useState } from "react";

import { makeStyles } from "@material-ui/styles";

import DupontCheckbox from "components/DupontCheckbox";

const useStyles = makeStyles(() => ({
  checkboxContainer: { display: "inline-block", verticalAlign: "middle" }
}));

const ChartTrendCheckboxRenderer = props => {
  const classes = useStyles();
  const fieldName = props.colDef?.field;
  const [isChecked] = useState(props.node.data[fieldName]);

  const selectionChangeHandler = Trendline => {
    const { data } = props.node;
    props.node.setData({ ...data, Trendline, isEdited: true });
    props.context.updateChartView(fieldName);
  };

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox checked={Boolean(isChecked)} onChange={selectionChangeHandler} />
    </span>
  );
};

export default ChartTrendCheckboxRenderer;
